import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  textarea,
  Container,
  UncontrolledTooltip,
  Table,
} from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
// import './CssForAll.css'
import PostApiCall from "../../Api";
import GetApiCall from "../../GETAPI";
import Notiflix from "notiflix";
import moment from "moment";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { MDBCol, MDBDataTableV5, MDBTableBody, MDBTableHead } from "mdbreact";
import GoldRateModal from "./GoldRateModal";

class AddDailyGoldRate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateGoldRateModal: false,
      todayDate: new Date(),
      GoldRateState: {
        date: new Date(),
        rate: "",
      },
    };
  }

  componentDidMount = () => {
    Notiflix.Loading.Init({
      svgColor: "#880105",
    });
  };

  toggleGoldRateModal = () => {
    this.setState({ updateGoldRateModal: !this.state.updateGoldRateModal });
  };
  setGoldRateStateDate = (newDate) => {
    this.setState({
      GoldRateState: {
        ...this.state.GoldRateState,
        date: newDate,
      },
    });
  };

  onPostAddGoldRate = (ndate, nrate) => {
    console.log("inside gold rate api call");
    PostApiCall.postRequest(
      {
        date: ndate,
        rate: nrate,
      },
      "Add_Daily_Gold_Rate"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          console.log(obj);
          Notiflix.Notify.Success("Sucessfuly updated gold rate ");
          window.location.reload();
        } else {
          Notiflix.Notify.Failure(obj.data);
        }
      })
    );
  };

  render() {
    const data = {
      columns: [
        {
          label: "S.No.",
          field: "sno",
          sort: "disabled",
          width: 400,
        },
        {
          label: "Date",
          field: "date",
          sort: "disabled",
          width: 400,
        },
        {
          label: "Gold Rate",
          field: "goldrate",
          sort: "disabled",
          width: 400,
        },
      ],
      rows: this.state.UserData?.filter((data) => {
        console.log(data.fld_email.toLowerCase(), this.state.searchInput);
        let name = [
          ...data.fld_name
            .toLowerCase()
            .matchAll(this.state.searchInput.toLowerCase()),
        ];

        if (this.state.searchInput.length > 0 && name[0]) {
          return data;
        }

        if (
          this.state.searchInput.length > 0 &&
          data.fld_email.toLowerCase() === this.state.searchInput.toLowerCase()
        ) {
          return data;
        }
        if (
          this.state.searchInput.length > 0 &&
          data.fld_mobile.toLowerCase() === this.state.searchInput.toLowerCase()
        ) {
          return data;
        }

        if (
          this.state.searchInput.length > 0 &&
          data.fld_status.toLowerCase() === this.state.searchInput.toLowerCase()
        ) {
          return data;
        }

        if (this.state.searchInput.length == 0) {
          return data;
        }
      }).map((data, i) => {
        return {
          sno: <td>{i + 1}</td>,
          date: <td>{new Date()}</td>,
          goldrate: <td>NA</td>,
        };
      }),
    };
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <GoldRateModal
              modalIsOpen={this.state.updateGoldRateModal}
              toggleGoldRateModal={this.toggleGoldRateModal}
              onPost={this.onPostAddGoldRate}
            />
            <Breadcrumbs
              title={"Max Xchange "}
              breadcrumbItem={"Add Gold Rate"}
            />
            <Row>
              <Col xl="12">
                <Card className="overflow-hidden">
                  <Row>
                    <Col xl="12">
                      <Card className="overflow-hidden">
                        <div className="maxXchange-bg-soft-pink">
                          <Row>
                            <Col xs="6">
                              <div className="maxXchange-text p-3">
                                <h5 className="maxXchange-text">
                                  Gold Rate List
                                </h5>
                              </div>
                            </Col>
                            <Col xs="6">
                              <div className="maxXchange-text p-3">
                                <p
                                  style={{
                                    float: "right",
                                    marginTop: "-5px",
                                  }}
                                  onClick={this.toggleGoldRateModal}
                                  className="btn align-items-center btn maxXchange-btn "
                                >
                                  Update Gold Rate
                                  <i
                                    className="fa fa-plus"
                                    aria-hidden="true"
                                  ></i>
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <CardBody className="pt-0">
                          <Row></Row>
                        </CardBody>
                        <CardBody className="pt-0">
                          <Row>
                            {/* <MDBCol md="3" style={{ marginBottom: "10px" }}>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search"
                            aria-label="Search"
                            onChange={(e) => this.seachBarHandler(e)}
                            value={this.state.searchInput}
                          />
                        </MDBCol> */}
                            <Col md="12">
                              <MDBDataTableV5
                                striped
                                bordered
                                small
                                data={data}
                                searchBottom={false}
                                seachTop={true}
                              >
                                <MDBTableHead columns={data.columns} />
                                <MDBTableBody rows={data.rows} />
                              </MDBDataTableV5>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>

                      {/* <WelcomeComp /> */}
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AddDailyGoldRate;
